import React, { Component, createRef } from 'react'
import { RichText } from '@sitecore-jss/sitecore-jss-react'  

import { isMobile, isNotAtTop } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { initAoxInViewport, destroyAoxInViewport } from '../../utilities/FrontFunctions/AoxInViewportClass'

import '../../../src/assets/css/0010_sections/0480_section_hero-main.css'

class SectionHeroHome2026 extends Component {
	constructor(props) {
		super(props)

		this.sectionRef = createRef()
		this.viewportObserver = null

		this.state = {
			isMobile: isMobile(),
			modeMini: isNotAtTop(),
			visuelBackground: "images/v_background_home.jpg",
			visuelBackgroundMob: "images/v_background_home_mob.jpg",
			isVisible: false
		}

	}

	componentDidMount() {
		window.addEventListener('resize', this.throttleWindowResizeMainHeader)
		window.addEventListener('scroll', this.throttleWindowScrollMainHeader)

		this.viewportObserver = initAoxInViewport({
			element: this.sectionRef.current,
			threshold: 0.2,
			rootMargin: '0px 0px -80px 0px',
			once: true,
			onEnter: () => {
				this.setState({ isVisible: true })
			}
		})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
		window.removeEventListener('scroll', this.throttleWindowScrollMainHeader)

		destroyAoxInViewport(this.viewportObserver)
	}

	render() {
		const {scFields} = this.props;
		const { isVisible } = this.state

		return (
			<section ref={this.sectionRef} className={`obj_section section_hero-main ${isVisible ? 'is-visible' : ''}`}>
				<div className='ctn_section'>
					<div className='obj_text'>
						<div className='ctn_text-header animation_reveal-item animation_reveal--fade-up animation_delay-1'>
                            <RichText field={scFields["Page Text"]} tag="h2" className="t_title title_large"/>
						</div>

						<div className='ctn_text animation_reveal-item animation_reveal--fade-up animation_delay-2'>
                            <p>{scFields["Page SubTitle"]?.value}</p>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default SectionHeroHome2026